import { connect } from 'react-redux';
import { createScopedActions } from '@mews-commander/utils';
import { getEnterpriseDefaultCurrencyCode } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import { getExchangeRatesWithoutDefault } from '../../reducers';
import {
    toggleConversionDirection,
    toggleConversionStatus,
    updateConversionValue,
    updateTouched,
    updateRatesWithFlash,
} from '../../actions';

export default connect(
    (state, { scope }) => ({
        // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
        exchangeRates: getExchangeRatesWithoutDefault(state, { scope }),
        // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
        enterpriseDefaultCurrencyCode: getEnterpriseDefaultCurrencyCode(state, { enterpriseId: scope }),
    }),
    createScopedActions({
        toggleConversionDirection,
        toggleConversionStatus,
        updateConversionValue,
        updateTouched,
        changeRates: updateRatesWithFlash,
    })
);
